import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { Grid, Typography, Button } from '@mui/material';
import Notice from 'components/Notice';
import renderHTML from 'html-react-parser';
import _ from 'lodash';
import CardGallery from 'components/CardGallery';
import ProductPanel from 'components/ProductPanel';
import renderContentBlock from 'utils/contentRenderer';
import { FormattedMessage } from 'react-intl';

export class LandingPage extends React.Component {
  galleryItems() {
    const { products, filter } = this.props;

    return _.filter(products, (c) => {
      if (filter) {
        // Replicate existing behaviour i.e. digital shows both digital and digital retailer
        // If we want to split digital might need a different panel in LandingPage for digital retailer
        return c.product_type.includes(filter) && c.active;
      } else {
        return c.active;
      }
    })
  }

  render() {
    const { site, config, filter } = this.props;

    return (
      <React.Fragment>
        {config.notice_enabled &&
          <Notice text={renderHTML(config.notice)} />
        }
        {site.landing_text &&
          <Typography component="div" align="center" style={{marginBottom: '3em'}}>{renderHTML(site.landing_text)}</Typography>
        }
        {(site.landing_product_selection && !filter) ?
          <Grid container spacing={1} justifyContent="center" align='center'>
            <Grid size={{xs: 12, md: 6}}>
              <Typography variant="h5" align="center" gutterBottom>
                <FormattedMessage id="landing.physical_cards" defaultMessage="Physical Gift Cards" />
              </Typography>
              <img src={site.landing_physical_image} className="landing-product-tile" alt='Physical' />
              <Typography component="div" align="center" gutterBottom>{renderHTML(site.landing_physical_features)}</Typography>
              <NavLink to="/physical" className='button-link'>
                <Button variant='contained' color='primary'>
                  <FormattedMessage id="landing.physical_proceed" defaultMessage="Buy Physical Gift Cards" />
                </Button>
              </NavLink>
            </Grid>
            <Grid size={{xs: 12, md: 6}}>
              <Typography variant="h5" align="center" gutterBottom>
                <FormattedMessage id="landing.digital_cards" defaultMessage="Digital Gift Cards" />
              </Typography>
              <img src={site.landing_digital_image} className="landing-product-tile" alt='Digital' />
              <Typography component="div" align="center" gutterBottom>{renderHTML(site.landing_digital_features)}</Typography>
              <NavLink to="/digital" className='button-link'>
                <Button variant='contained' color='primary'>
                  <FormattedMessage id="landing.digital_proceed" defaultMessage="Buy Digital Gift Cards" />
                </Button>
              </NavLink>
            </Grid>
          </Grid>
        :
          <React.Fragment>
            {site.featured_products ?
              <React.Fragment>
                <Typography variant="h5" component="h1" align="center" className="top-space bottom-space">
                  <FormattedMessage id="landing.featured_products" defaultMessage="Featured products" />
                </Typography>
                <CardGallery site={site} cardDesigns={site.featured_products} />
                <NavLink to="/products">
                  <Typography variant="h5" align="center">
                    <FormattedMessage id="landing.view_all" defaultMessage="View All" />
                  </Typography>
                </NavLink>
              </React.Fragment>
            :
              <CardGallery site={site} cardDesigns={this.galleryItems()} filter={filter} />
            }
          </React.Fragment>
        }

        {site.best_selling_products?.length > 0 &&
          <ProductPanel products={site.best_selling_products} headingKey="landing.best_selling_products" headingFallback="Best Selling Products" />
        }

        {site.content_blocks.length > 0 &&
          <Grid container spacing={1} justifyContent="center" align='center'>
            <Grid size={{xs: 12}} style={{marginTop: '3em'}} />
            {site.content_blocks.map((block, index) =>
              <Grid key={index} size={{xs: 12}} className="content-block-container">
                {block.title && block.template != 'two_columns' && block.template != 'video' && block.template != 'logo_text' &&
                  <Typography variant="h5" align="left" className="bottom-space">{block.title}</Typography>
                }
                {renderContentBlock(block)}
                {index + 1 != site.content_blocks.length &&
                  <hr style={{margin: '2em 0'}} />
                }
              </Grid>
            )}
          </Grid>
        }
      </React.Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    products: state.product.products,
    config: state.site.config
  };
}

export default connect(mapStateToProps, {})(LandingPage);
